<template>
  <div
    :style="[colorData.colorStyles]"
    :class="[colorData.colorClasses]"
    class="graph-legend-percentage action white--text"
  >
    {{ value | roundNumber(0) }} %
  </div>
</template>

<script>
import { getBackgroundColorData } from './colorUtils'

export default {
  name: 'GraphLegendPercentage',

  props: {
    value: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },

  computed: {
    colorData () {
      return getBackgroundColorData(this.color)
    }
  }
}
</script>

<style lang="scss" scoped>
.graph-legend-percentage {
  display: flex;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.6;
}
</style>
